module.exports = __webpack_public_path__ + "static/media/Simona-Hriscu-resume.4164c62a.pdf";